import { LOINCAnswerCodes } from "@/fhir/enums/loinc";

/** @deprecated Prefer {@link LOINCAnswerCodes.Yes}. */
export const LOINC_ANSWER_YES = LOINCAnswerCodes.Yes;

/** @deprecated Prefer {@link LOINCAnswerCodes.No}. */
export const LOINC_ANSWER_NO = LOINCAnswerCodes.No;

export interface LoincAnswerCoding {
  code?: string;
  display?: string;
}

/** Questionnaire form shapes for a LOINC Yes/No choice field. */
export interface LoincAffirmativeYesFormValueObject {
  code?: string;
  display?: string;
  valueCoding?: LoincAnswerCoding;
}

export type LoincAffirmativeYesFormValue = string | LoincAffirmativeYesFormValueObject;

/**
 * Returns true when a FHIR valueCoding answer indicates LOINC "Yes" by code or display text.
 */
export function isLoincAffirmativeYesFromCoding(coding: LoincAnswerCoding | undefined): boolean {
  if (!coding) {
    return false;
  }

  return coding.code === LOINCAnswerCodes.Yes || coding.display?.toLowerCase() === "yes";
}

/**
 * Returns true when a LOINC "Yes" answer is represented in questionnaire form values
 * (string code, display-only string, flat code/display, or nested valueCoding).
 */
export function isLoincAffirmativeYesFromFormValue(
  raw: LoincAffirmativeYesFormValue | null | undefined,
): boolean {
  if (raw == null || raw === "") {
    return false;
  }

  if (typeof raw === "string") {
    return raw === LOINCAnswerCodes.Yes || raw.toLowerCase() === "yes";
  }

  if (raw.code === LOINCAnswerCodes.Yes) {
    return true;
  }

  if (raw.display?.toLowerCase() === "yes") {
    return true;
  }

  if (raw.valueCoding) {
    return isLoincAffirmativeYesFromCoding(raw.valueCoding);
  }

  return false;
}
